import React, { useState } from 'react';
import ConsentSettings from '../../components/admin/compliance/ConsentSettings';
import RetentionPolicy from '../../components/admin/compliance/RetentionPolicy';
import DSRList from '../../components/admin/compliance/DSRList';
import AuditTrail from '../../components/admin/compliance/AuditTrail';
import EmailComplianceSettings from '../../components/admin/compliance/EmailComplianceSettings';

const ComplianceDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'email' | 'consent' | 'dsr' | 'retention' | 'audit'>('email');
  const [programId, setProgramId] = useState<string>('');

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Compliance & Privacy</h1>
      <p className="text-sm text-gray-600">Manage consent, data subject requests, retention, and audit logs.</p>

      <div className="flex items-center gap-3">
        <label htmlFor="programId" className="text-sm font-medium">Program ID</label>
        <input
          id="programId"
          value={programId}
          onChange={(e) => setProgramId(e.target.value)}
          className="border rounded px-3 py-2 w-80"
          placeholder="Enter program ID"
        />
      </div>

      <div className="border-b">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {[
            { id: 'email', label: 'Email Compliance' },
            { id: 'consent', label: 'Consent' },
            { id: 'dsr', label: 'DSR' },
            { id: 'retention', label: 'Retention' },
            { id: 'audit', label: 'Audit Trail' },
          ].map((t) => (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id as any)}
              className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
                activeTab === t.id ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'email' && <EmailComplianceSettings />}
      {activeTab === 'consent' && <ConsentSettings programId={programId} />}
      {activeTab === 'dsr' && <DSRList />}
      {activeTab === 'retention' && <RetentionPolicy programId={programId} />}
      {activeTab === 'audit' && <AuditTrail />}
    </div>
  );
};

export default ComplianceDashboard;
